import { Animation, ClientData, cyrb64, getAnimationPoint, ID, useLogger } from "@kosmod/kit"
import { PlayerID } from "@kosmod/sesame"

import * as three from 'three';

import { TheatrePosition, ToolStateRaw } from "../../defs"
import { Component, h, useEffect, useMemo, useRef } from "@lukekaalim/act";
import { a3 } from "@lukekaalim/act-three";
import { renderBeat, useDisposable } from "@kosmod/graphics-3d";
import { TheatreState } from "../../hooks/useTheatreState";
import { getHandlerForTool } from "../Tools";

export type PlayerCursorProps = {
  id: PlayerID,

  cursor: ClientData<TheatrePosition | null>,
  tool: ToolStateRaw | null,

  theatre: TheatreState,
}

const geometry = new three.SphereGeometry(.1);

function easeOutQuad(x: number): number {
  return 1 - (1 - x) * (1 - x);
}
export const PlayerCursor: Component<PlayerCursorProps> = ({ cursor, tool, id, theatre }) => {
  if (id === theatre.data.self.id)
    return null;
  
  const ref = useRef<three.Mesh | null>(null);

  const logger = useLogger('PlayerCursor').createSubsystem(id);

  const animationRef = useRef(() => Animation(0, 0, [
    new three.Vector3(),
    new three.Vector3()
  ], ([left, right], p) => left.lerp(right, p)));

  const material = useDisposable(() => {
    const hash = cyrb64(id);
    const color = new three.Color().setHSL(hash / Number.MAX_SAFE_INTEGER, 1, .5)
    
    logger.log(`Player Color`, id, color)
    return new three.MeshStandardMaterial({ color })
  }, [id])

  useEffect(() => {
    const sub = cursor.change.subscribe((cursor) => {
      positionRef.set(cursor)

      if (cursor) {
        const now = performance.now();
        const current = getAnimationPoint(animationRef.get(), now);
        const animation = Animation(
          now, 10,
          [current, TheatrePosition.copyToVector3(cursor)],
          animationRef.get().interpolate
        );
        animationRef.set(animation)
      }
    });
    return () => sub.unsubscribe();
  }, [cursor])

  // renderBeat.useBeat((now) => {
  //   const mesh = ref.get()!;

  //   if (cursor.current) {
  //     mesh.visible = true;
  //     const current = getAnimationPoint(animationRef.get(), now);
  //     mesh.position.copy(current)
  //   } else {
  //     mesh.visible = false;
  //   }
  // });

  const previewTool = tool && getHandlerForTool(tool.type);
  const positionRef = useRef(cursor.current);

  useEffect(() => {
    logger.warn(`Remote Tool`, { tool });
  }, [previewTool])

  return [
    // h(a3.mesh, { geometry, ref, material }),
    !!previewTool && !!previewTool.PreviewComponent && !!tool && h(previewTool.PreviewComponent, {
      cursorPosition: positionRef,
      toolState: { ...tool, id: ID('theatre:tool') },
      theatre: {
        ...theatre,
        cursorPosition: positionRef,
      },
      material,
    }),
  ]
}